module.exports = __webpack_public_path__ + "static/media/remixicon.d0d23961.svg";